import { Show } from "solid-js";

import { axisPrimaryColor } from "~/components/header/header_axis";

export function Name(props: { name: string; clientId: string }) {
  return (
    <span
      class="text-f12Bold uppercase text-[#59ABFF] sm:text-[16px]"
      style={{
        color: axisPrimaryColor,
      }}
    >
      <Show when={props.name}>👋 &nbsp{`${props.name}`}</Show>
      <Show when={!props.name}>WELCOME</Show>
    </span>
  );
}

export function GetGiftCardText(props: { text?: string }) {
  return (
    <div class="z-10 flex w-full flex-row items-center justify-center gap-4 px-5 sm:px-[156px]">
      {buildArrow()}
      <span class="text-nowrap text-normal text-basePrimaryMedium">
        {props.text ?? "Get gift card(s) from choice of brands"}
      </span>

      <div class="w-full rotate-180">{buildArrow()}</div>
    </div>
  );

  function buildArrow() {
    return (
      <div
        class="h-[1px] w-full "
        style={{
          "border-radius": "2px",
          background:
            "linear-gradient(270deg, #313538 0%, rgba(49, 53, 56, 0.00) 100%)",
        }}
      >
        &nbsp;
      </div>
    );
  }
}
